const ROOT = 'PAYMENT_METHOD_CREDIT_ADD_MODAL_';

const actions = {
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  ADD_CREDIT_REQUEST: `${ROOT}ADD_CREDIT_REQUEST`,
  ADD_CREDIT_SUCCESS: `${ROOT}ADD_CREDIT_SUCCESS`,
  ADD_CREDIT_ERROR: `${ROOT}ADD_CREDIT_ERROR`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  CHANGE_MODAL_VISIBILITY: `${ROOT}CHANGE_MODAL_VISIBILITY`,
} as const;

export default actions;
